//LeaveReports
<template>
  <div>
    <v-snackbar v-model="snackbar" top :color="color" :timeout="6000" rounded elevation="2">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text small @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="pa-4 rounded-xl elevation-2">
      <!-- Tabs -->
      <v-tabs v-model="tabs" background-color="brand" dark grow slider-color="yellow" class="rounded-xl no-display">
        <v-tab>
          <v-icon left>mdi-file-document-outline</v-icon>
          Yearly Report
        </v-tab>
        <v-tab>
          <v-icon left>mdi-calendar-month</v-icon>
          Monthly Report
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabs" >
        <!-- Leave Balance Report Tab -->
        <v-tab-item>
          <v-card flat>
            <leave-balance-report></leave-balance-report>
          </v-card>
        </v-tab-item>

        <!-- Monthly Leave Data Report Tab -->
        <v-tab-item>
          <v-card flat class="pt-1">        
            <monthly-leave-data-report></monthly-leave-data-report>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import LeaveBalanceReport from "../Admin/LeaveBalanceReport.vue";
import MonthlyLeaveDataReport from "./MonthlyLeaveDataReport.vue";

export default {
     components: {
    LeaveBalanceReport,
    MonthlyLeaveDataReport
  },
  data() {
    return {     
      snackbar_msg: "",
      color: "",
      snackbar: false,
      tabs: 0,
    };
  },

  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },

  mounted() {},
};
</script>

<style scoped>
.v-tabs {
  border-radius: 12px;
}

.v-tab {
  font-weight: bold;
  letter-spacing: 0.5px;
}
@media print{
     .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
}
</style>
